import {
    deleteSubject,
    getActKeys,
    getAggregateReport,
    getAllUsers,
    getAvatarChange,
    getFriendDuel,
    getKeysProgress,
    getLeveUp,
    getRandomDuel,
    getSubjectMenus,
    getSubjects,
    getUserActivity,
    getUserMetrics,
    getUserPopularity,
    postAvatarAudioChange,
    postAvatarBackgroundChange,
    postAvatarChange,
    postCreateActKey,
    postCreateSubject,
    postFriendDuelAudio,
    postFriendDuelAvatar,
    postFriendDuelBackground, postKeyProgress, postStarLevelUpAnimation, postLevelUpAvatar,
    postRandomDuelAudio,
    postRandomDuelAvatar, postRandomDuelBackground,
    putAssignToUser,
    putCreateSubject,
    putSubjectMenus,
    updateGrade, postLevelUpSound, postAvatarForegroundChange, postFriendDuelForeground, postRandomDuelForeground
} from "./requests";
import {useMutation, useQuery} from "@tanstack/react-query";
import {queryKeys} from "../../app/react-query/constants";
import {
    ActKeyQueriesTypes,
    AllUsersQueriesTypes,
    IActKeyBody,
    IExportActKeys,
    IPutAssignToUser,
    IPutGrade, userActivitiesParamsType, userContentsParamsType, userMetricParamsType
} from "../models";

export function useGetSubjects(id?:number|string) {
    return useQuery({
        queryFn: () => getSubjects(id),
        queryKey: [queryKeys.SUBJECTS, id],
        enabled: !!id,
        staleTime: 0
    });
}

export function usePostCreateSubject() {
    return useMutation({
        mutationFn: (reqData: { formData:FormData,gradeId:string }) => postCreateSubject(reqData.formData,reqData.gradeId),
        mutationKey: [queryKeys.CREATE_SUBJECTS]
    })
}

export function useDeleteSubject(){
    return useMutation({
        mutationFn: (reqData: { gId?:number|string, sId?:number|string }) => deleteSubject(reqData.gId,reqData.sId),
        mutationKey: [queryKeys.DELETE_SUBJECTS]
    })
}

export function useUpdateGrade(){
    return useMutation({
        mutationFn: (data:{id: string | number, body:IPutGrade
        }) => updateGrade(data.id, data.body),
        mutationKey: [queryKeys.UPDATE_GRADE]
    })
}

export function usePutUpdateSubject() {
    return useMutation({
        mutationFn: (reqData: { formData:FormData,gradeId:string , subjectId:string}) => putCreateSubject(reqData.formData,reqData.gradeId, reqData.subjectId),
        mutationKey: [queryKeys.UPDATE_SUBJECTS]
    })
}

export function useGetSubjectMenus(id: number) {
    return useQuery({
        queryFn: () => getSubjectMenus(id),
        queryKey: [queryKeys.GET_SUBJECT_MENUS],
        enabled: !!id,
        staleTime:0
    })
}

export function usePutSubjectMenus (subjectId:number) {
    return useMutation({
        mutationFn: (data:{mId:number, reqData: FormData}) => putSubjectMenus(subjectId, data.mId, data.reqData),
        mutationKey: [queryKeys.PUT_SUBJECT_MENUS],
    })
}

export function useGetActKeys (ActKeyQueries:ActKeyQueriesTypes) {
    return useQuery({
        queryFn: () => getActKeys(ActKeyQueries),
        queryKey: [queryKeys.GET_ACT_KEYS],
        retry: false,
    })
}

export function usePostCreateActKey () {
    return useMutation({
        mutationFn: (data:IActKeyBody) => postCreateActKey(data),
        mutationKey: [queryKeys.POST_ACT_KEY],
    })
}

export function usePutAssignToUser () {
    return useMutation({
        mutationFn: (data: { actKeyId:number, assignId:IPutAssignToUser }) => putAssignToUser(data.actKeyId, data.assignId),
        mutationKey: [queryKeys.PUT_ASSIGN_TO_USER],
    })
}

export function useGetAllUsers (AllUsersQueries:AllUsersQueriesTypes) {
    return useQuery({
        queryFn: () => getAllUsers(AllUsersQueries),
        queryKey: [queryKeys.GET_ALL_USERS, AllUsersQueries.search]
    })
}

export function useGetAggregateReport (id: string) {
    return useQuery({
        queryFn: () => getAggregateReport(id),
        queryKey: [queryKeys.GET_AGG_REPORTS, id]
    })
}
export function useGetUserMetrics (userMetricParams:userMetricParamsType) {
    return useQuery({
        queryFn: () => getUserMetrics(userMetricParams),
        queryKey: [queryKeys.GET_USER_METRICS, userMetricParams]
    })
}
export function useGetUserPopularity (userMetricParams:userContentsParamsType) {
    return useQuery({
        queryFn: () => getUserPopularity(userMetricParams),
        queryKey: [queryKeys.GET_USER_CONTENTS, userMetricParams]
    })
}

export function useGetUserActivity (userMetricParams:userActivitiesParamsType) {
    return useQuery({
        queryFn: () => getUserActivity(userMetricParams),
        queryKey: [queryKeys.GET_USER_ACTIVITIES, userMetricParams]
    })
}

export function useGetAvatarChange () {
    return useQuery({
        queryFn: () => getAvatarChange(),
        queryKey: [queryKeys.GET_AVATAR_CHANGE]
    })
}

export function useGetFriendDuel () {
    return useQuery({
        queryFn: () => getFriendDuel(),
        queryKey: [queryKeys.GET_FRIEND_DUEL]
    })
}

export function useGetRandomDuel () {
    return useQuery({
        queryFn: () => getRandomDuel(),
        queryKey: [queryKeys.GET_RANDOM_DUEL]
    })
}

export function useGetKeysProgress () {
    return useQuery({
        queryFn: () => getKeysProgress(),
        queryKey: [queryKeys.GET_KEYS_PROGRESS]
    })
}

export function useGetLeveUp () {
    return useQuery({
        queryFn: () => getLeveUp(),
        queryKey: [queryKeys.GET_LEVEL_UP]
    })
}

export function usePostAvatarAudioChange () {
    return useMutation({
        mutationFn: (data: FormData) => postAvatarAudioChange(data),
        mutationKey: [queryKeys.POST_CHANGE_AVATAR_AUDIO],
    })
}

export function usePostAvatarBackgroundChange () {
    return useMutation({
        mutationFn: (data: FormData) => postAvatarBackgroundChange(data),
        mutationKey: [queryKeys.POST_CHANGE_AVATAR_BACKGROUND],
    })
}
export function usePostAvatarForegroundChange () {
    return useMutation({
        mutationFn: (data: FormData) => postAvatarForegroundChange(data),
        mutationKey: [queryKeys.POST_CHANGE_AVATAR_FOREGROUND],
    })
}
export function usePostAvatarChange () {
    return useMutation({
        mutationFn: (data: FormData) => postAvatarChange(data),
        mutationKey: [queryKeys.POST_CHANGE_AVATAR],
    })
}

export function usePostFriendDuelAvatar () {
    return useMutation({
        mutationFn: (data: FormData) => postFriendDuelAvatar(data),
        mutationKey: [queryKeys.POST_FRIEND_DUEL_AVATAR],
    })
}

export function usePostFriendDuelAudio () {
    return useMutation({
        mutationFn: (data: FormData) => postFriendDuelAudio(data),
        mutationKey: [queryKeys.POST_FRIEND_DUEL_AUDIO],
    })
}

export function usePostFriendDuelBackground () {
    return useMutation({
        mutationFn: (data: FormData) => postFriendDuelBackground(data),
        mutationKey: [queryKeys.POST_FRIEND_DUEL_BACKGROUND],
    })
}
export function usePostFriendDuelForeground () {
    return useMutation({
        mutationFn: (data: FormData) => postFriendDuelForeground(data),
        mutationKey: [queryKeys.POST_FRIEND_DUEL_FOREGROUND],
    })
}
export function usePostRandomDuelAvatar () {
    return useMutation({
        mutationFn: (data: FormData) => postRandomDuelAvatar(data),
        mutationKey: [queryKeys.POST_RANDOM_DUEL_AVATAR],
    })
}

export function usePostRandomDuelAudio () {
    return useMutation({
        mutationFn: (data: FormData) => postRandomDuelAudio(data),
        mutationKey: [queryKeys.POST_FRIEND_DUEL_AUDIO],
    })
}

export function usePostRandomDuelBackground () {
    return useMutation({
        mutationFn: (data: FormData) => postRandomDuelBackground(data),
        mutationKey: [queryKeys.POST_FRIEND_DUEL_BACKGROUND],
    })
}
export function usePostRandomDuelForeground () {
    return useMutation({
        mutationFn: (data: FormData) => postRandomDuelForeground(data),
        mutationKey: [queryKeys.POST_RANDOM_DUEL_FOREGROUND],
    })
}
export function usePostKeyProgress () {
    return useMutation({
        mutationFn: (data: FormData) => postKeyProgress(data),
        mutationKey: [queryKeys.POST_KEY_PROGRESS],
    })
}

export function usePostLevelUpAvatar () {
    return useMutation({
        mutationFn: (data: FormData) => postLevelUpAvatar(data),
        mutationKey: [queryKeys.POST_LEVEL_UP_AVATAR],
    })
}

export function usePostStarLevelUpAnimation () {
    return useMutation({
        mutationFn: (data: FormData) => postStarLevelUpAnimation(data),
        mutationKey: [queryKeys.POST_LEVEL_UP_STAR],
    })
}

export function usePostLevelUpSound () {
    return useMutation({
        mutationFn: (data: FormData) => postLevelUpSound(data),
        mutationKey: [queryKeys.POST_LEVEL_UP_AUDIO],
    })
}